import { createContext } from 'react';

import { Page } from '../../types/__generated__';

export type PageMetaContextValues = {
  pageGuid?: string;
  isInvite: boolean;
  isPreview: boolean;
  isCampaignsV1: boolean;
  currentUrl: string;
  pageType: string;
  pageShortName?: string;
  pageSlug?: string;
  basePageData?: Page | null;
  metaTagImageUrl?: string;
  metaTagDescription?: string;
  error?: {
    status: number;
    messageKey: string;
  };
  showBanner?: boolean;
  bannerCopy?: string;
  displayAlertOnly?: boolean;
};

export const PageMetaContext = createContext<PageMetaContextValues | null>(
  null,
);

export const PageMetaContextProvider = PageMetaContext.Provider;
